export const DEFAULT_LANG = 'en_us'
export const DEFAULT_CURRENCY = 'USD'
export const DEFAULT_CURRENCY_SYMBOL = '$'
export const DEFAULT_COUNTRY_CODE = 'US'
export const DEFAULT_STORE_ID = 1011
export const DEFAULT_STORE_OBJECT_ID = '5b1abe30a4d4531b8fe40725'
